import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
import { calendarEvents } from './homeData';
interface AstroCalendarSectionProps {
  onNavigate: (page: string) => void;
}
export function AstroCalendarSection({
  onNavigate
}: AstroCalendarSectionProps) {
  return <AnimatedSection className="py-8 sm:py-24 bg-slate-50" data-id="element-15778">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15779">
        <div className="flex justify-between items-end mb-4 sm:mb-12" data-id="element-15780">
          <div data-id="element-15781">
            <h2 className="text-lg sm:text-3xl font-bold text-slate-900 mb-1 sm:mb-3" data-id="element-15782">
              Астрологический календарь
            </h2>
            <p className="text-xs sm:text-lg text-slate-500" data-id="element-15783">
              Важные небесные события
            </p>
          </div>
          <Button variant="ghost" className="hidden md:flex text-slate-500" onClick={() => onNavigate('astro-daily')} data-id="element-15784">
            Открыть календарь <ArrowRight className="ml-2 w-4 h-4" data-id="element-15785" />
          </Button>
        </div>

        {/* Mobile: compact list */}
        <div className="sm:hidden space-y-2.5" data-id="element-15786">
          {calendarEvents.map(event => <div key={event.id} className="flex items-center gap-3 bg-white rounded-xl border border-slate-100 p-3 cursor-pointer" onClick={() => onNavigate('calendar-event')} data-id="element-15787">
              <div className={`p-2 rounded-lg border ${event.accent} flex-shrink-0`} data-id="element-15788">
                {event.icon}
              </div>
              <div className="min-w-0" data-id="element-15789">
                <div className="flex items-center gap-2" data-id="element-15790">
                  <span className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-15791">
                    {event.type}
                  </span>
                  <span className="text-[10px] font-bold text-slate-900" data-id="element-15792">
                    {event.date}
                  </span>
                </div>
                <h3 className="text-xs font-bold text-slate-900" data-id="element-15793">
                  {event.title}
                </h3>
              </div>
            </div>)}
        </div>

        {/* Desktop: grid */}
        <motion.div className="hidden sm:grid md:grid-cols-3 gap-6" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-15794">
          {calendarEvents.map(event => <motion.div key={event.id} variants={staggerItem} data-id="element-15795">
              <Card hoverable padding="lg" className="cursor-pointer border-slate-100 h-full" onClick={() => onNavigate('calendar-event')} data-id="element-15796">
                <div className="flex items-center gap-3 mb-4" data-id="element-15797">
                  <div className={`p-2.5 rounded-xl border ${event.accent}`} data-id="element-15798">
                    {event.icon}
                  </div>
                  <div data-id="element-15799">
                    <div className="text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-15800">
                      {event.type}
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-15801">
                      {event.date}
                    </div>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-15802">
                  {event.title}
                </h3>
                <p className="text-sm text-slate-500" data-id="element-15803">{event.desc}</p>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </AnimatedSection>;
}